// @flow
import type { Node } from 'react';
import * as React from 'react';
import Notification from '../domain/Notification';

type Props = {
  notification: Notification,

  onClick: (n: Notification) => any,
  renderNotification: (n: Notification) => Node,
}

export default function NotificationToast(props: Props) {
  const { notification, renderNotification, onClick } = props;

  return (
    <div onClick={(e) => {
      e.stopPropagation();
      onClick(notification);
    }}
    >
      {renderNotification(notification)}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/common/modules/ui/components/NotificationToast.js